import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const OddsFormatWrapper = withConfig(theme => styled('div', { label: 'OddsFormatWrapper' })`
    display: flex;
    flex-flow: column nowrap;
    gap: ${theme.star.gap.medium};
`);

export const BalanceInHeaderWrapper = styled('div', { label: 'BalanceInHeaderWrapper' })`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const BalanceInHeaderTitleWrapper = withConfig(theme => styled('div', { label: 'BalanceInHeaderTitleWrapper' })`
    display: flex;
    flex-flow: column nowrap;
    gap: ${theme.star.gap.small};
`);

export const ToggleWrapper = withConfig(theme => styled('div', { label: 'ToggleWrapper' })`
    display: flex;
    gap: ${theme.star.gap.medium};
`);


export const BalanceText = withConfig(theme => styled('h3', { label: 'BalanceText' })`
    font-size: ${theme.star.fontSize.xRegular};
    font-weight: ${theme.star.fontWeight.xMedium};
    line-height: ${theme.star.lineHeight[250]};
    margin: 0;
`);

export const BalanceWrapper = withConfig(theme => styled('div', { label: 'BalanceWrapper' })`
    display: flex;
    gap: ${theme.star.gap.small};
    align-items: center;
`);



export const Header = withConfig(theme => styled('h3', { label: 'Header' })`
    font-size: ${theme.star.fontSize.regular};
    line-height: 1.5;
    margin: 0;
`);
